(function($) {
	/** Event nasłuchujący wciskane klawisze
	 *
	 * @param {object} event - Obiekt przechowujący informacje jaki klawisz został wciśnięty
	*/
	$(window).on('keydown', function(event){
		/** Rozwinięta lista (a dokładniej input, zdarzenia są przypisane do inputa) dowolnego selecta */
		var element = $('.select3-container.expanded input');
		/** Jesli jakaś lista jest rozwinięta */
		if(element.length > 0) {
			event.preventDefault();
			/** Strzałka do góry */
			if ( event.which === 38 ) {
				element.select3('keyup');
			}
			/** Strzałka na dół */
			else if ( event.which === 40 ) {
				element.select3('keydown');
			}
			/** Wciśnięty enter */
			else if ( event.which === 13 ) {
				element.select3('select');
			}
			/** Wciśnięty escape */
			else if ( event.which === 27 ) {
				element.select3('close');
			}
			/** Inne klawisze */
			else {
				element.select3('search', event);
			}
		}
	});
	/**
	 * Główna funkcja pluginu
	 *
	 * @param {string} setting - Dodatkowy parametr, z którym można wywyłać plugin - parametr musi być nazwą metody
	 * @param {object} event - Obiekt przechowujący informacje o wciśniętym klawiszu
	 */
	$.fn.select3 = function(setting, event) {
		return this.each(function() {
			/** Jeśli plugin wywołano bez parametru - domyślnie działanie */
			if(typeof setting !== 'string') {
				/** @type {object} $input - główny input przechowujący i przekazujący dane (ukryty dla użytkownika) */
				var $input = $(this);
				/** @type {object} $container - zawiera wszystkie inne elementy */
				var $container = $(this).parent();
				/** @type {object} $selectedItemPreview - pokazuje obecnie zaznaczony element */
				var $selectedItemPreview = $(this).parent().find('.select3-selected-item');
				/** @type {object} $optionList - lista wszystkich opcji do wyboru */
				var $optionList = $(this).parent().find('.select3-option-list');
				/** @type {object} $selectedOption - obecnie zaznaczona opcja */
				var $selectedOption = $(this).parent().find('.select3-option-selected');
				/** @type {object} $highlightedOption - obecnie podświetlona opcja */
				var $hightlightedOption;
				/** @type {object} $option - pojedyncza opcja z listy */
				var $option = $(this).parent().find('.select3-option');
				/** @type {object} $firstOption - pierwsza opcja na liście */
				var $firstOption = $(this).parent().find('.select3-option:first');
				/** @type {object} $lastOption - ostatnia opcja na liście */
				var $lastOption = $(this).parent().find('.select3-option:last');
				/** @type {object} $selectionArrow - strzałka pokazująca rozwinięcie/zwinięcie selecta */
				var $selectionArrow = $(this).parent().find('.select3-selection-arrow');
				/** @type {boolean} changeSelectValueMode - zmienna sterująca trybem funkcji changeSelectValue 
				 * 
				 * false - domyślnie aby pozwolić na zmianę value inputa z zewnątrz 
				 * true - dla operacji wewnątrz pluginu - clicku na opcji, strzałka w dół, strzałka w górę
				*/
				var changeSelectValueMode = false;
				/** @type {object} $toSelect - opcja, która ma być zaznaczona */
				var $toSelect;
				/** @type {object} $toHighlight - opcja, która ma być podświetlona */
				var $toHighlight;
				//START SCROLL
				/** @type {object} $optionListWrap - dodatkowy wrap dla listy opcji, który jest scrollowany */
				var $optionListWrap = $(this).parent().find('.select3-option-list-wrap');
				/** Ustawienia pluginu/scrolla
				 *
				 * DO PRZEROBIENIA
				 * optionHeight - wysokość całkowita jednej opcji
				 * visibleOptions - maksymalna ilość widocznych opcji bez scrolla
				 * numberOfOptions - całkowita ilość opcji
				 */
				var select3Settings = {
					optionHeight: $option.outerHeight(),
					visibleOptions: 20,
					numberOfOptions: $option.length
				};
				/** Jeżeli całkowita ilość opcji jest większa od ilości widocznych opcji - aktywuj scroll */
				if(select3Settings.numberOfOptions > select3Settings.visibleOptions ) {
					/** Dodaj klasę pluginu do przewijanego elementu
					 * Wymagane
					 */
					$optionListWrap.addClass('simplebar');
					/** Ustawienie wysokości wrapu opcji = wysokość jednej opcji * ilość widocznych opcji */
					$optionListWrap.css({
						height: function(){
							return (select3Settings.optionHeight * select3Settings.visibleOptions);
						}
					});
					/** Wywołanie pluginu scrolla */
					$optionListWrap.simplebar();
				}
				// KONIEC SCROLL
				/** Inicjalizacja eventów */
				function initEvents(){
					/** Click na kontenerze */
					$container.on('click', function(){
						clickContainer();
					});
					/** Click na opcji z listy */
					$option.on('click', function(){
						/** Funkcja wybierająca podświetloną opcję */
						selectHighlightedItemFromList();
					});
					/** Mouseenter nad opcją */
					$option.on('mouseenter', function(event){
						/** Funkcja podświetlająca opcję */
						highlightItemFromList(event.target);
					});
					/** Zmiana wartości inputa */
					$input.on('change', function(){
						/** Funkcja zmiany opcji/value inputa */
						changeSelectValue();
					});
					/** 
					 * Click w dowolnym miejscu w dokumencie 
					 * 
					 * * @param {object} event - Do rozpoznania co zostało kliknięte
					*/
					$(document).click(function(event){
						/** Funkcja chowająca listę opcji
						 *
						 * Uruchamia się jeśli NIE kliknięto na kontenerze z selectem
						 * Bez tego propagacja otworzy i od razu zamknie listę opcji
						 */
						if( !$(event.target).closest('.select3-container').length ) {
							hideOptionList();
						}
					});
				}
				/** Funkcja wczytująca początkowe wartości */
				function loadDefaultValues(){
					/** Jeśli żadna opcja nie jest domyślnie zaznaczona */
					if ( $selectedOption.length === 0 ){
						/** Ustaw wartość inputa równą wartości pierwszej opcji z listy */
						$input.val( $firstOption.data('value') ).change();
						/** Wstaw tekst pierwszej opcji z listy w miejscu pokazującym obecnie zaznaczoną opcję */
						$selectedItemPreview.text( $firstOption.text() );
						/** Zaznacz pierwszą opcję z listy */
						$firstOption.addClass('select3-option-selected');
					}
					/** Jeśli jakaś opcja jest zaznaczona np. przakazano jej atrubyt selected */ 
					else {
						/** Zaktualizuj wartość inputa */
						$input.val( $selectedOption.data('value') );
						/** Wstaw tekst zaznaczonej opcji z listy w miejscu pokazującym obecnie zaznaczoną opcję */
						updatePreview();
					}
				}
				/** Funkcja sterująca selectem po zmianie jego value */
				function changeSelectValue(){
					/** False - zmiana value inputa z zewnątrz */ 
					if(changeSelectValueMode === false){
						/** Przechowywanie nowego value inputa po zmianie */
						var newInputValue = $input.val();
						/** Zmienna pomocnicza określająca czy nowy value istnieje dla jakiejś opcji */
						var newValueExists = false;
						/** Przeszukaj każdą opcje na liście */
						$option.each(function(){
							/** Jeśli value którejś opcji pasuje do tej w inpucie */
							if( ($(this).data('value')) === newInputValue ){
								/** Wstaw tekst tej opcji w miejscu pokazującym obecnie zaznaczoną opcję */
								$selectedItemPreview.text( $(this).text() );
								/** Odznacz poprzednią opcję */
								$selectedOption = $container.find('.select3-option-selected');
								$selectedOption.removeClass('select3-option-selected');
								/** Zaznacz tę opcję - dodaj klasę */
								$(this).addClass('select3-option-selected');
								/** Zapisz nową opcję jako zaznaczoną */
								$selectedOption = $container.find('.select3-option-selected');
								/** Value istnieje w opcji na liście */
								newValueExists = true;
								/** Gdy znaleziono - przestań szukać i opuść each */
								return false;
							}
						});
						/** Gdy żadna opcja nie ma takiego value - zaznacz pierwszą na liście */
						if(!newValueExists){
							/** Wstaw tekst pierwszej opcji z listy w miejscu pokazującym obecnie zaznaczoną opcję */
							$selectedItemPreview.text( $firstOption.text() );
							/** Odznacz poprzednią opcję */
							$selectedOption = $container.find('.select3-option-selected');
							$selectedOption.removeClass('select3-option-selected');
							/** Zaznacz pierwszą opcję z listy */
							$firstOption.addClass('select3-option-selected');
							/** Zapisz nową opcję jako zaznaczoną */
							$selectedOption = $container.find('.select3-option-selected');
							/** Ustaw wartość inputa równą wartości pierwszej opcji z listy */
							$input.val( $firstOption.data('value') );
						}
					}
					/** Zmiana value inputa od wewnątrz - click na opcji lub Enter przy podświetlonej opcji */
					else {
						/** Nadpisz referencję obecnie zaznaczonej opcji */
						$selectedOption = $container.find('.select3-option-selected');
						/** Odznacz opcję */
						$selectedOption.removeClass('select3-option-selected');
						/** Nadpisz referencję obecnie zaznaczonej opcji */
						$selectedOption = $toSelect;
						/** Zaznacz opcję klasą */
						$selectedOption.addClass('select3-option-selected');
						/** Wstaw tekst opcji w miejscu pokazującym obecnie zaznaczoną opcję */
						updatePreview();
					}
					/** Reset zmiennej sterującej */
					changeSelectValueMode = false;
				}
				function clickContainer(){
					/** Schowaj wszystkie inne listy opcji */
					hideAllOtherOptionLists();
					/** Sprawdź czy lista obecnie klikniętego containera jest ukryta */
					if ( optionListHidden() ){
					/** Pokaż listę opcji */
						showOptionList();
					}
					else {
					/** Ukryj listę opcji */
						hideOptionList();
					}
				}
				/** Funkcja wstawiająca tekst zaznaczonej opcji do miejsca pokazującego obecnie zaznaczoną opcję */
				function updatePreview(){
					$selectedItemPreview.text( $selectedOption.text() );
				}
				/** Funkcja sprawdzająca czy lista opcji jest w tej chwili UKRYTA */
				function optionListHidden(){
					if ( $optionList.hasClass('select3-list-hidden') ) {
						/** Zwróć true - lista jest ukryta */
						return true;
					}
					else {
						/** Zwróć false - lista jest widoczna */
						return false;
					}
				}
				/** Funkcja pokazująca listę opcji */
				function showOptionList(){
					$optionList.removeClass('select3-list-hidden');
					/** Zmień kierunek strzałki rozwinięcia */
					switchArrow();
				}
				/** Funkcja ukrywająca listę opcji */
				function hideOptionList(){
					/** Jeżeli lista jest WIDOCZNA */
					if( !optionListHidden() ){
						/** Zmień kierunek strzałki rozwinięcia */
						switchArrow();
					}
					/** Ukryj listę */
					$optionList.addClass('select3-list-hidden');
					/** Wyczyść podświetlenie opcji */
					clearHighlight();
				}
				/** Funkcja zmieniająca kierunek strzałki rozwinięcia listy */
				function switchArrow() {
					$container.toggleClass('expanded');
				}
				/** Funkcja ukrywająca wszystkie inne listy opcji 
				 * Tylko 1 ma być w danej chwili widoczna
				 * Warunek '.not' wykluczający obecny container jest wymagany
				 * Bez warunku click na containerze z rozwiniętą listą, 
				 * schowa ją, sprawdzi czy jest schowana i znowu ją pokaże
				*/
				function hideAllOtherOptionLists(){
					$('.select3-container').not($container).removeClass('expanded');
					$('.select3-container').not($container).find('.select3-option-list').addClass('select3-list-hidden');
				}
				/** Funkcja zaznaczająca podświetloną opcję */
				function selectHighlightedItemFromList() {
					/** Zmień wartość parametru aby uruchomić tryb operacji wewnątrz pluginu - click opcji, strzałki */
					changeSelectValueMode = true;
					/** Przekaż podświetloną opcję do zaznaczenia */
					$toSelect = $hightlightedOption;
					/** Zmień value inputa */
					$input.val( $toSelect.data('value') ).change();
				}
				/** Funkcja czyszcząca podświetlenie opcji */
				function clearHighlight(){
					$('.select3-option-highlighted').removeClass('select3-option-highlighted');
					$hightlightedOption = undefined;
				}
				/**
				 * Funkcja podświetlająca opcję
				 *
				 * @param {object} element - przekazujemy funkcji element do zaznaczenia
				 */
				function highlightItemFromList(element){
					/** Usuń wcześniejsze podświetlenie */
					$('.select3-option-highlighted').removeClass('select3-option-highlighted');
					/** Zaznacz element */
					$(element).addClass('select3-option-highlighted');
					/** Zaktualizuj zmienną */
					$hightlightedOption = $(element);
				}
				/** Funkcja podświetlania następnej opcji na liście */
				function highlightNextItemFromList(event){
					/** Jesli żadna nie jest podświetlona */
					if( $hightlightedOption === undefined){
						/** Podświetl pierwszą */
						highlightItemFromList($firstOption);
					}
					else {
						/** Jeśli istnieje następna od obecnie podświetlonej */
						if( $hightlightedOption.next().length > 0){
							/** Podświetl ją */
							$toHighlight = $hightlightedOption.next();
							highlightItemFromList($toHighlight);
						}
						else {
							/** Podświetl pierwszą */
							highlightItemFromList($firstOption);
						}
					}
				}
				/** Funkcja podświetlania poprzedniej opcji na liście */
				function highlightPreviousItemFromList(event){
					/** Jesli żadna nie jest podświetlona */
					if( $hightlightedOption === undefined){
						/** Podświetl ostatnią */
						highlightItemFromList($lastOption);
					}
					else {
						/** Jeśli istnieje poprzednia od obecnie podświetlonej */
						if( $hightlightedOption.prev().length > 0){
							/** Podświetl ją */
							$toHighlight = $hightlightedOption.prev();
							highlightItemFromList($toHighlight);
						}
						else {
							/** Podświetl ostatnią */
							highlightItemFromList($lastOption);
						}
					}
				}
				/**
				 * Funkcje publiczne dla zmiany zaznaczonej opcji spoza pluginu
				 * Przechowywane jako data dla każdej instancji pluginu
				 * keyup - strzałka do góry - poprzednia opcja
				 * keydown - strzałka na dół - następna opcja
				 * close - ESC - ukryj listę opcji
				 * select - ENTER - zaznacz podświetloną opcję
				 */
				function keyup(event){
					highlightPreviousItemFromList(event)
				}
				function keydown(event){
					highlightNextItemFromList(event)
				}
				function close(event){
					hideOptionList();
				}
				function select(event){
					selectHighlightedItemFromList();
					/** Brak clicku - trzeba zamknąć listę manualnie */
					hideOptionList();
				}
				function search(event){
					/** String wciśniętego klawisza w lowerCase */
					var pressedKeyString = String.fromCharCode(event.keyCode).toLowerCase();
					/** Przeszukaj wszystkie opcje */
					$option.each(function(){
						/** Weź text tej opcji, usuń spacje, weź pierwszy znak, zmień na lowercase
						 * Jeśli wynik jest równy wciśniętemu klawiszowi
						 */
						if( $(this).text().trim().charAt(0).toLowerCase() === pressedKeyString ){
							/** Podświetl tę opcję */
							highlightItemFromList($(this));
							/** Skończ each */
							return false;
						}
					}); 
				}
				$(this).data('select3keyup',keyup);
				$(this).data('select3keydown',keydown);
				$(this).data('select3select',select);
				$(this).data('select3close',close);
				$(this).data('select3search',search);
				
				initEvents();
				loadDefaultValues();
			}
			else {
				/** Zmienna do wywoływania funkcji publicznych */
				var functionCaller;
				/** Jeśli element posiada data o nazwie równej przekazanemu parametrowi setting */
				if( $(this).data('select3' + setting) !== undefined ){
					/** Wywołaj to co kryje się pod data */
					functionCaller = $(this).data('select3' + setting);
					/** Event zawiera informacje o wciśniętym klawiszu dla wyszukiwania */
					functionCaller(event);
				}
			}
		});
	}
})(jQuery);